import { useEffect, useState } from 'react';



const useCheckMobileScreen = (maxDeviceWidth = 768) => {
  const [ width, setWidth ] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    const ac = new AbortController();

    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      ac.abort();
    };
  }, []);

  return (width <= maxDeviceWidth);
};

export default useCheckMobileScreen;
